import { CollapseSection } from './CollapseSection'
export default CollapseSection
